import React from 'react';
import { ProductCard } from './ProductCard';
import { useProducts } from '../context/ProductContext';
export const FeaturedProducts: React.FC = () => {
  const {
    featuredProducts
  } = useProducts();
  return <section className="py-12 bg-white dark:bg-gray-900" data-id="element-52">
      <div className="container mx-auto px-4" data-id="element-53">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-8" data-id="element-54">
          Featured Products
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-55">
          {featuredProducts.map(product => <ProductCard key={product.id} product={product} data-id="element-56" />)}
        </div>
      </div>
    </section>;
};